<template>
    <div class="shadow" style="padding: 15px 30px;width:100%">
        <div class="chartStyle " ref="scanActivityByMonth"></div>
    </div>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
    data(){
        return {
            chart : null,
            interval: null
        }
    },
    props : ['data'],
    mounted(){
        this.createChart();
        
    },
    watch : {
        data : {
            deep : true,
            immediate : true,
            handler : 'getData',
        }
    },
    methods : {
        getData(){
            var length = this.chart.data.length;
            this.chart.addData(this.data && this.data.length > 0 ? this.data : [{month:'No Data', count:0}], length);
        },
        createChart(){
            this.chart = am4core.create(this.$refs.scanActivityByMonth , am4charts.XYChart);
            this.chart.hiddenState.properties.opacity = 0;

            // this.chart.data = this.sampleData();

            let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "month";
            categoryAxis.renderer.minGridDistance = 40;
            categoryAxis.fontSize = 11;
            categoryAxis.title.text = "Year";

            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            // valueAxis.strictMinMax = true;
            valueAxis.renderer.minGridDistance = 30;
            valueAxis.title.text = "Number of Vehicle";

            let series = this.chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryX = "month";
            series.dataFields.valueY = "count";
            series.columns.template.tooltipText = "Quantity of Mapped Vehicles in {categoryX} : {valueY.value}";
            series.columns.template.tooltipY = 0;
            series.name = "Number of Vehicles"
            series.columns.template.strokeOpacity = 0;
            var labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "[bold]{valueY}";
            labelBullet.label.dy = -15;
            
            //add legend
            this.chart.legend = new am4charts.Legend();
            this.chart.legend.position = "bottom";
            //add cursor
            this.chart.cursor = new am4charts.XYCursor();
        },
        sampleData(){
            return [
                {
                    country: "USA",
                    count: 23725
                },
                {
                    country: "China",
                    count: 1882
                },
                {
                    country: "Japan",
                    count: 1809
                },
                {
                    country: "Germany",
                    count: 1322
                },
                {
                    country: "UK",
                    count: 1122
                },
                {
                    country: "France",
                    count: 1114
                },
                {
                    country: "India",
                    count: 984
                },
                {
                    country: "Spain",
                    count: 711
                },
                {
                    country: "Netherlands",
                    count: 665
                },
                {
                    country: "Russia",
                    count: 580
                },
                {
                    country: "South Korea",
                    count: 443
                },
                {
                    country: "Canada",
                    count: 441
                }
            ];
        }
    }
}
</script>

<style scoped>
    .chartStyle{
        min-height: 400px;
        /* background-color: white; */
    }
</style>